export default "__VITE_ASSET__BB1ip30m__"